import React from "react";
import { Card, CardBody, CardTitle } from "reactstrap";
import { Switch, Route } from "react-router-dom";
import EnterVoucher from "./VoucherRedemption/EnterVoucher";
import RedeemVoucher from "./VoucherRedemption/RedeemVoucher";
import RedeemThumbnail from "../../assets/images/redeemThumbnail.png";
export default function ValidateVoucher() {
  return (
    <Card>
      <CardTitle className="border-bottom p-3 mb-0 font-weight-bold text-uppercase">
        <i class="fas fa-check-double"></i>
        Validate Voucher
      </CardTitle>
      <CardBody>
        <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
          <div
            onClick={() => {
              window.open('https://www.youtube.com/watch?v=ynDX0wdhVDo&list=PLmis7uALvV_yqG16ihUzjTFdEKBqtEkR0&t=222', '_blank').focus();
            }}
            style={{ display: "flex", marginRight: 32, cursor: 'pointer' }}>
            <div style={{ fontSize: 14, lineHeight: 1.3, whiteSpace: 'break-spaces', fontStyle: 'italic', marginRight: 8, fontWeight: 'bold', color: '#7460ee', width: 47 }}>
              {"How to\nvideo"}
            </div>
            <img
              src={RedeemThumbnail}
              style={{
                height: 170,
                width: 314,
              }}
            />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            <p className="text-secondary" style={{ whiteSpace: 'break-spaces' }}>
              {"Enter the voucher number shown on your customer’s mobile device and click Submit to process.\nSelect the store or category from the dropdown menu and click, Redeem."}
            </p>
            <Switch>
              <Route
                path="/process-voucher/redeem/:code"
                render={(props) => <RedeemVoucher {...props} />}
              />
              <Route
                path="/process-voucher"
                render={(props) => <EnterVoucher {...props} />}
              />
            </Switch>
          </div>
        </div>
      </CardBody>
    </Card>
  );
}
